import type { FormApi } from 'final-form';

import type { TFields } from '../components/form/models/index';

/**
 * У final-form не нашли метода для проверки валидности всей формы.
 * Функция проверяет валидность всех полей в форме.
 */
export const getValidatorFromForm =
    <T extends TFields>(form: FormApi<T> | null) =>
    () =>
        form?.getRegisteredFields().every(field => {
            const state = form.getFieldState(field);

            return !!(state && state.valid);
        });
